import React,{useReducer,useEffect} from 'react';
import { injectIntl, FormattedMessage, FormattedPlural } from 'react-intl';
import { i18nIntl } from '../../lib/ep';
import { SortableContainer, SortableElement, SortableHandle, arrayMove } from 'react-sortable-hoc';

import { SquaredButton } from '../builder/ActionButton';

const DragHandle = SortableHandle(() => {
	return (
		<div class="sorter_target">
			<SquaredButton
				icon='knk-sorter-target-v'
				color={false}
				_class={{ other:'remove_vote is_sorting_target blackIcon whiteButton' }}
				aria-label="Sort media"
			/>
		</div>
	)
});

const SortableFields = SortableContainer(({ items, stage, data, ...props }) => {
	const i18n = (m, c) => i18nIntl(m, props.intl, c);
	const type = (stage.voting_type != undefined) ? stage.voting_type : 'simple';
	const editing_votes = (props.editing_votes != undefined) ? props.editing_votes : false;

	const gallery_proportion = stage?.gallery_proportion ?? '15x12';

	return (
		<ul class="votes_list">
			{items.map((item, index) => {
				let tier_name = false;
				let score_to_give = false;
				let score_to_give_code = false;
				switch(type) {
					case 'tiered':
						if(data.tiers[index].tier_name != undefined && data.tiers[index].tier_name != "") tier_name = data.tiers[index].tier_name;
						score_to_give = data.tiers[index].tier_score;
						score_to_give_code = <strong>{tier_name}</strong>;
						break;

					case 'ponderated':
						if(data.tiers[index] != undefined) score_to_give = data.tiers[index].tier_score;
						score_to_give_code = <FormattedPlural value={score_to_give} one={<FormattedMessage id="{num} point" values={{num:score_to_give}} />} other={<FormattedMessage id="{num} points" values={{num:score_to_give}} />} />;
						break;

					case 'simple':
					default:
						const min_votes = parseInt((stage.voting_min != undefined) ? stage.voting_min : 1);

						tier_name = (index < min_votes) ? i18n("Mandatory") : i18n("Optional");
						score_to_give = false;
						break;
				}

				return (
					<li key={index} class="voting_slot gui_pos_rel">
						<span class="tier_specs">
							<span>
								{(score_to_give_code !== false) && (
									<span class="points">{score_to_give_code}</span>
								)}
							</span>
						</span>

						<img src={`${window.cdn_url}img/blank_${gallery_proportion}.png`} width="100%" alt="" />

						<SortableItem
							index={index}
							item={item}
							display_target={(item !== false && type != 'simple' && !editing_votes) ? true : false}
							editing_votes={editing_votes}
							pos={index}
							{...data}
							dispatch={props.dispatch}
							points_to_give={score_to_give_code}
						/>
					</li>
				)
			})}
		</ul>
	);
});

const SortableItem = SortableElement((props) => {
	const field = props.field;

	const display_target = (props.display_target != undefined) ? props.display_target : true;
	const points_to_give = (props.points_to_give != undefined) ? props.points_to_give : false;
	const editing_votes = (props.editing_votes != undefined) ? props.editing_votes : false;

	const change = (k, v) => {
		props.dispatch({ type:'CHANGE_VALUE', id:field.id, k, v });
	};

	const container_item = document.getElementById('ep-global-contents');
	const layout_class = (container_item != undefined && container_item.classList.contains('bl_bg')) ? 'bl_bg' : 'wt_bg';

	return (
		<div class={`gui_sortable_item awesome ${layout_class}`}>
			{(points_to_give && props.item !== false) && (
				<span class="is_floating_points">{points_to_give}</span>
			)}

			<ul>
				{React.cloneElement(props.element, { index:props.pos, item:props.item })}
			</ul>

			{(display_target) && (
				<DragHandle />
			)}
		</div>
	)
});

const CartSortable = ({ items, stage, ...props }) => {
	const i18n = (m, c) => i18nIntl(m, props.intl, c);

	const [state, dispatch] = useReducer((state, action) => {
		switch (action.type) {
			case 'SET_ITEMS':
				return { ...state, items:[...action.items] };

			case 'SORT':
				let new_order = arrayMove(state.items, action.oldIndex, action.newIndex);
				if(props.onChange != undefined) props.onChange(new_order);
				return { ...state, items:[ ...new_order ] };

			case 'DELETE':
				let newstate = {...state, fields:state.fields.filter((f) => f.id != action.id)};
				if(props.onChange != undefined) props.onChange(newstate.fields);
				return newstate;

			case 'SETOPEN':
				return { ...state, open:(action.id == state.open) ? false : action.id };

			case 'CHANGE_VALUE':
				for(var i in state.fields) {
					if(state.fields[i].id != action.id) continue;
					state.fields[i] = { ...state.fields[i], [action.k]:action.v };
					if(props.onChange != undefined) props.onChange(state.fields);
					return { ...state, fields:[...state.fields] };
				}
				return state;

			default:
				return state;
		}
	}, { items:items, open:false });

	const editing_votes = (props.editing_votes != undefined) ? props.editing_votes : false;

	useEffect(() => {
		if(props.onChange != undefined) props.onChange(state.items);
	}, []);

	useEffect(() => {
		dispatch({ type:'SET_ITEMS', items });
	}, [items]);

	const onSortEnd = ({ oldIndex, newIndex }) => {
		dispatch({ type:'SORT', oldIndex, newIndex });
	};

	return (
		<SortableFields
			data={{
				element:props.children,
				tiers:props.tiers,
			}}
			axis={(props.sort_axis != undefined) ? props.sort_axis : "y"}
			dispatch={dispatch}
			intl={props.intl}
			items={items}
			onSortEnd={onSortEnd}
			stage={stage}
			editing_votes={editing_votes}
			useDragHandle={true}
		/>
	)
}

export default injectIntl(CartSortable);